export default async (context:any, payload:any) => {
    const moduleId = context.getters.moduleId;
    await context.dispatch('call', payload, { root: true });

    context.commit('setAttribute', {
        id: `${moduleId}_task`,
        attribute: 'options',
        value: context.rootState.appState.data.tasks,
    }, {
        root: true,
    });
};